import React from 'react';
import { ReactComponent as Icon } from './../../../../asset/icons/genderless.svg';

const IconGenderless = () => {
  return <Icon></Icon>;
};

export default IconGenderless;
